import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Container,
  Grid,
  Card,
  CardContent,
  Avatar,
  Paper,
  useTheme,
  useMediaQuery,
  IconButton,
  Icon,
  Divider,
  Stack,
  Modal,
  Tooltip,
  SvgIcon,
} from "@mui/material";
import {
  Assessment as TrackProgressIcon,
  Feedback as FeedbackIcon,
  LibraryBooks as QuestionBankIcon,
  QueryBuilder as TimerIcon,
  School as TutorIcon,
  Star as StarIcon,
} from "@mui/icons-material";
import CheckIcon from "@mui/icons-material/Check";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import SchoolIcon from "@mui/icons-material/School";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import LockIcon from "@mui/icons-material/Lock";
import PersonIcon from "@mui/icons-material/Person"; // Example for the 500+ students icon
import { SvgIconComponent } from "@mui/icons-material";
import "./Landingpage.scss";
import {
  AutoAwesome as AiIcon,
  School as ExpertIcon,
  TrendingUp as ProgressIcon,
  PhoneAndroid as MobileIcon,
  AllInclusive as UnlimitedIcon,
} from "@mui/icons-material";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
} from "@mui/material";
import Dashimage from "./LandingPageImage/landingpage.png";
import ARimage from "./LandingPageImage/ARimage.png";
import QAimage from "./LandingPageImage/QAimage.png";
import ReadingImage from "./LandingPageImage/Readingimage.png";
import WritingImage from "./LandingPageImage/WritingIMage.png";
import Mintraing from "./LandingPageImage/MInIMage.png";
import Skilltraing from "./LandingPageImage/image.png";
import TrendingUpIcon from "@mui/icons-material/TrendingUp"; // or any similar icon
import PsychologyAltIcon from "@mui/icons-material/PsychologyAlt"; // brain icon
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CenterFocusStrongIcon from "@mui/icons-material/CenterFocusStrong";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import VideocamIcon from "@mui/icons-material/Videocam";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import Viedoimage from "./LandingPageImage/Rectangle 10.png"; // Adjust the path based on the folder structure
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { AppBar, Toolbar, useScrollTrigger, Slide } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ReactComponent as MobileLoginLogo } from "../../Assets/Images/loginlogo.svg";
import LoginIcon from "@mui/icons-material/Login";
import { useNavigate } from "react-router-dom";
import playLogo from "./LandingPageImage/pepicons-pencil_camera.png";
import playbutton from "./LandingPageImage/Playbutton.png";
import brainbutton from "./LandingPageImage/Ai-brain.png";
import targetbutton from "./LandingPageImage/target.png";
import brainbuttoncolor from "./LandingPageImage/ai-brain-01.png";
import tradebuttoncolor from "./LandingPageImage/proicons_graph.png";
import Drawer from "@mui/material/Drawer";
import AOS from "aos";
import "aos/dist/aos.css";
import heroSection from "../../Assets/Images/Web_Image 1.jpg";
import abstractReasoning from "../../Assets/Images/Abstract_Reasining.png";
import writingTest from "../../Assets/Images/Writing_tests.png";
import readingcomprehension from "../../Assets/Images/Reading_Comprehensions.png";
import quantitativeReasoning from "../../Assets/Images/Quantitative_Reasonings.png";
import examSimulation from "../../Assets/Images/Web_Image 2.jpg";
import performanceEnhancement from "../../Assets/Images/Web_Image 3.jpg";
import {
  motion,
  useAnimation,
  useAnimationFrame,
  useMotionValue,
} from "framer-motion";
import { Target, BookOpen, Brain, LineChart } from "lucide-react";

interface FeatureItemProps {
  icon: SvgIconComponent;
  title: string;
}

interface Plan {
  name: string;
  price: string;
  billingCycle?: string;
  description: string;
  features: string[];
  isRecommended?: boolean;
  buttonText: string;
  buttonVariant: "outlined" | "contained";
  buttonColor: "primary" | "secondary";
  disabledFeatures?: string[];
}

const Landingpage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const controls = useAnimation();
  const x = useMotionValue(0);
  const SPEED = 0.5;

  const items = [
    { text: "2,000+ GATE-Ready Practice Questions", checked: false },
    { text: "AI Marking & Feedback in Writing", checked: true },
    { text: "AI Rewrite your text + AI Exemplar for Writing", checked: false },
    {
      text: "Auto-Tracking of Strengths, Weaknesses, & Progress",
      checked: false,
    },
    { text: "Questions assorted by Topics", checked: false },
  ];
  const itemLanding = [
    { text: "True-to-Exam Mock Papers", checked: false },
    { text: "Instant AI-Generated Performance Reports", checked: true },
    { text: "Strength & Weakness Breakdown", checked: false },
    { text: "Score Forecasts Based on Real Data", checked: false },
  ];

  const itemLandingpaddig = [
    { text: "Time-Bound Critical Thinking Challenges", checked: false },
    { text: "Personalized Training Based on Past Attempts", checked: true },
    { text: "Custom Focus Areas: Verbal, Quant, Logic", checked: false },
    {
      text: "AI Coaching to Strengthen Weak Points",
      checked: false,
    },
  ];
  const features = [
    {
      icon: <TrackProgressIcon fontSize="large" />,
      title: "Track Your Progress",
      description:
        "See detailed analytics showing strengths, weaknesses, and improvement over time.",
    },
    {
      icon: <FeedbackIcon fontSize="large" />,
      title: "Get Instant Feedback from AI",
      description:
        "Writing responses are marked in real time with personalized suggestions for improvement. Ask our Smart Tutor for help with reading.",
    },
    {
      icon: <QuestionBankIcon fontSize="large" />,
      title: "Attempt Real GATE-style Questions",
      description:
        "Practice from over 2,000 curated questions, designed by WA 99+ ATAR Tutors.",
    },
  ];

  const featureslist = [
    {
      icon: <SchoolIcon fontSize="inherit" />,
      title:
        "Used by students from Perth Modern School, Rossmoyne, Willetton, and more.",
    },
    {
      icon: <LightbulbIcon fontSize="inherit" />,
      title: "Built by medical students & former GATE top scorers.",
    },
    {
      icon: <LockIcon fontSize="inherit" />,
      title: "Secure and compliant platform (100% student data privacy)",
    },
    {
      icon: <StarIcon fontSize="inherit" />,
      title: "500+ students currently using the platform.",
    },
  ];

  const topFeatures = [
    {
      icon: <AiIcon color="primary" fontSize="large" />,
      title: "AI-Powered Marking Engine",
      description:
        "Receive instant feedback just like having a tutor by your side, 24/7.",
    },
    {
      icon: <ExpertIcon color="primary" fontSize="large" />,
      title: "Expertly Crafted Question Bank",
      description:
        "All questions are designed by former GATE students and top academic achievers.",
    },
    {
      icon: <UnlimitedIcon color="primary" fontSize="large" />,
      title: "Unlimited Practice",
      description:
        "Train as much as you like. Our free tier lets you try it, and our premium plans unlock full access.",
    },
    {
      icon: <ProgressIcon color="primary" fontSize="large" />,
      title: "Progress Tracking",
      description:
        "Visual dashboards show your strengths and highlight areas for improvement.",
    },
    {
      icon: <MobileIcon color="primary" fontSize="large" />,
      title: "Mobile-Friendly",
      description:
        "Study anytime, anywhere – compatible with phones, tablets, and laptops.",
    },
  ];

  const benefits = [
    {
      title: "AI-Powered Practice That Accelerates Growth",
      items: [
        "2,000+ GATE-Ready Practice Questions",
        "AI Marking & Feedback in Writing",
        "AI Rewrite your text + AI Exemplar for Writing",
        "Auto-Tracking of Strengths, Weaknesses, & Progress",
      ],
    },
    {
      title: "Train Like It's the Real Exam",
      items: [
        "True-to-Exam Mock Papers",
        "Instant AI-Generated Performance Reports",
        "Strength & Weakness Breakdown",
        "Score Forecasts Based on Real Data",
      ],
    },
    {
      title: "Sharpen the Skills That Matter Most",
      items: [
        "Time-Bound Critical Thinking Challenges",
        "Personalized Training Based on Past Attempts",
        "Custom Focus Areas: Verbal, Quant, Logic",
        "AI Coaching to Strengthen Weak Points",
      ],
    },
  ];

  const platformFeatures = [
    {
      icon: <TutorIcon fontSize="large" />,
      title: "AI-Powered Marking Engine",
      description:
        "Receive instant feedback just like having a tutor by your side, 24/7.",
    },
    {
      icon: <QuestionBankIcon fontSize="large" />,
      title: "Expertly Crafted Question Bank",
      description:
        "All questions are designed by former GATE students and top academic achievers.",
    },
    {
      icon: <ProgressIcon fontSize="large" />,
      title: "Unlimited Practice",
      description:
        "Train as much as you like. Our Free tier lets you try it, and our premium plans unlock Full access.",
    },
    {
      icon: <MobileIcon fontSize="large" />,
      title: "Mobile-Friendly",
      description:
        "Study anytime, anywhere — compatible with phones, tablets, and laptops.",
    },
  ];

  const pricingPlans: Plan[] = [
    {
      name: "Free Plan",
      price: "$0",
      billingCycle: "Forever",
      description: "Perfect for trying out our platform.",
      features: ["15 QR, AR & Reading Questions", "1 AI-Marked Writing Task"],
      disabledFeatures: [
        "Full Length Timed Mock Exams",
        "All AI-Powered Skill Trainer Modules",
        "Access to Newly Released Questions",
      ],
      buttonText: "Start Free",
      buttonVariant: "outlined",
      buttonColor: "primary",
    },
    {
      name: "Premium Plan",
      price: "$9.69",
      billingCycle: "per week, billed monthly",
      description: "Everything you need for GATE success.",
      features: [
        "2000+ GATE Questions (QR, AR & Reading)",
        "Unlimited Writing Prompts with AI Marking",
        "Full Length Timed Mock Exams",
        "All AI-Powered Skill Trainer Modules",
        "Access to Newly Released Questions",
      ],
      isRecommended: true,
      buttonText: "Go Premium",
      buttonVariant: "contained",
      buttonColor: "primary",
    },
    // You can add more pricing plans here
  ];

  const testimonials = [
    {
      name: "Neethu",
      role: "Parent (Yr 6 Student)",
      quote:
        "The AI feedback helped my daughter improve her written responses so quickly. This is a game-changer!",
    },
    {
      name: "Raj",
      role: "Parent (Yr 5 Student)",
      quote:
        "We tried many programs before, but Everest's AI feedback is on another level. My son's writing scores improved within weeks!",
    },
    {
      name: "Michael",
      role: "Parent (Yr 4 Student)",
      quote:
        "My son enjoys the instant feedback. He's motivated to keep improving because he can see his progress right away.",
    },
    {
      name: "Sarah",
      role: "Year 6 Student",
      quote:
        "The practice exams are just like the real ones! I feel so much more confident about the actual test now.",
    },
    {
      name: "Zihan",
      role: "Year 5 Student",
      quote:
        "The instant marking was so helpful, I knew what to fix straight away!",
    },
    {
      name: "Emily",
      role: "Year 4 Student",
      quote:
        "I love how the system explains my mistakes. It's like having a tutor available whenever I need help!",
    },
    {
      name: "David",
      role: "Parent (Yr 5 Student)",
      quote:
        "The personalized learning path keeps my daughter engaged. She's developing critical thinking skills I didn't expect!",
    },
    {
      name: "Ling",
      role: "Year 6 student",
      quote:
        "I improved my reading comprehension score by 35% in just two months using Everest's structured approach.",
    },
    {
      name: "Amir",
      role: "Parent (Yr 4 Student)",
      quote:
        "The adaptive question selection is brilliant - it always challenges my son at just the right level.",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const scrollRef = useRef<HTMLDivElement>(null);

  const scrollToIndex = (index: number) => {
    const container = scrollRef.current;
    if (container && container.children[index]) {
      (container.children[index] as HTMLElement).scrollIntoView({
        behavior: "smooth",
        inline: "start",
        block: "nearest",
      });
    }
  };

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => {
      const newIndex = prevIndex > 0 ? prevIndex - 1 : testimonials.length - 1;
      scrollToIndex(newIndex);
      return newIndex;
    });
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => {
      const newIndex = prevIndex < testimonials.length - 1 ? prevIndex + 1 : 0;
      scrollToIndex(newIndex);
      return newIndex;
    });
  };

  const faqData = [
    {
      question: "Is this aligned with the real GATE exam?",
      answer:
        "Yes – our question bank is modeled after actual GATE and ASET formats used in WA.",
    },
    {
      question: "How is the AI feedback different from other tools?",
      answer:
        "Our AI provides specific, written explanations – not just right/wrong answers. It analyzes your response patterns and offers targeted improvement suggestions.",
    },
    {
      question: "Do I need to enter payment details for the free trial?",
      answer:
        "No. Get started without entering any credit card information. We believe in our product enough to let you try it risk-free.",
    },
    {
      question: "Can I cancel or switch plans anytime?",
      answer:
        "Yes – you're in full control. Cancel or upgrade at any time through your account settings with no hidden fees or commitments.",
    },
    {
      question: "How often is new content added?",
      answer:
        "We regularly update our question bank with new content and improve our AI engine based on educational research and user feedback.",
    },
  ];

  const FeatureItem: React.FC<FeatureItemProps> = ({ icon, title }) => (
    <Grid item xs={12} sm={6} md={2.4} sx={{ textAlign: "center" }}>
      <Typography variant="subtitle1" sx={{ display: "flex" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "50%",
            width: "50%",
            height: 48,
            color: "#3a7bd5",
            bgcolor: "#d3edf5", // Or a light blue from your theme
            mx: "auto",
            mb: 1,
          }}
        >
          <Icon component={icon} sx={{ color: "primary", fontSize: 28 }} />
        </Box>{" "}
        {title}
      </Typography>
    </Grid>
  );

  const steps = [
    {
      icon: <Target style={{ color: "#009DFF" }} />,
      title: "Choose Question Type",
      description:
        "Maths (QR), Reading, Writing & Abstract Reasoning - all aligned with GATE/ASET Standards",
      border: "linear-gradient(to right, #7F00FF, #E100FF)", // Purple
    },
    {
      icon: <BookOpen style={{ color: "#009DFF" }} />,
      title: "Attempt Real GATE-style Questions",
      description:
        "Practice from over 2,000 curated questions, designed by WA 99+ ATAR Tutors",
      border: "linear-gradient(to right, #FF416C, #FF4B2B)", // Red
    },
    {
      icon: <Brain style={{ color: "#009DFF" }} />,
      title: "Get Instant Feedback from AI",
      description:
        "Writing responses are marked in real time with personalized suggestions for improvement. Ask our Smart Tutor for help with reading.",
      border: "linear-gradient(to right, #FF6A00, #EE0979)", // Orange-Pink
    },
    {
      icon: <LineChart style={{ color: "#009DFF" }} />,
      title: "Track Your Progress",
      description:
        "See detailed analytics showing strengths, weaknesses, and improvement over time.",
      border: "linear-gradient(to right, #00C9FF, #92FE9D)", // Blue-Green
    },
  ];

  // video is list

  const [openvideo, setOpenvideo] = useState(false);

  const handleOpen = () => setOpenvideo(true);
  const handleClosevideo = () => setOpenvideo(false);
  const [isPaused, setIsPaused] = useState(false);

  // video list
  const videoList = [
    {
      id: 1,
      title:
        "GATE EXAM Sample Quick Walkthrough - Abstract Reasoning - WA 2025",
      time: "11:03",
      url: "https://www.youtube.com/embed/_6nPzWtZQKs?si=-2BuDfDeBQ6DIo5N",
    },
    {
      id: 2,
      title:
        "GATE EXAM Sample Full Walkthrough - Reading Comprehension - WA 2025",
      time: "34:54",
      url: "https://www.youtube.com/embed/MuBpPJ7Mgns?si=1kR0POSP828pVmmk",
    },
    {
      id: 3,
      title: "GATE EXAM Sample Full Walkthrough - Writing - WA 2025",
      time: "23:26",
      url: "https://www.youtube.com/embed/Eg0Jo5tDtNE?si=migH1w7N_zdAhqj-",
    },
    {
      id: 4,
      title:
        "GATE EXAM Sample Full Walkthrough - Quantitative Reasoning - WA 2025",
      time: "52:53",
      url: "https://www.youtube.com/embed/nKkoTJrcMzY?si=XnCZCRBKtVw9aYoS",
    },

    {
      id: 5,
      title:
        "Dr Jags's Speech PQRST Technique | Everest Tutoring | Harrisdale & Thornlie",
      time: "02:55",
      url: "https://www.youtube.com/embed/6vLA62hq-HU?si=rGJC5DkbRR-FzLjZ", // you can replace this with a new one if needed
    },
    {
      id: 6,
      title: "ATAR Physics WACE 2023 Predictions PART 1!",
      time: "01:30",
      url: "https://www.youtube.com/embed/VzqBisvh52k?si=dgtVK23WKJyGDqGA", // you can replace this with a new one if needed
    },
    {
      id: 7,
      title: "ATAR Physics WACE 2023 Prediction PART 3!",
      time: "01:27",
      url: "https://www.youtube.com/embed/sdF8xtcVphQ?si=MCPE8Ft-NtWNLvKj", // you can replace this with a new one if needed
    },
  ];

  const [currentIndexset, setCurrentIndexset] = useState(0);
  const currentVideo = videoList[currentIndexset];

  const handleNextvideo = () => {
    setCurrentIndexset((prev) => (prev + 1) % videoList.length);
  };

  const handlePrevideo = () => {
    setCurrentIndexset(
      (prev) => (prev - 1 + videoList.length) % videoList.length
    );
  };

  const handleVideoSelect = (index: number) => {
    setCurrentIndexset(index);
  };
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToElement = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setMobileMenuOpen(false);
    }
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      mirror: false,
      offset: 50,
    });

    AOS.refresh();
  }, []);

  const cardContent = [
    {
      title: "Abstract Reasoning",
      description:
        "Pattern recognition questions to test your logical thinking skills",
    },
    {
      title: "Writing Test",
      description: "Essay prompts with AI-powered feedback and marking",
    },
    {
      title: "Quantitative Reasoning",
      description: "Math problems to evaluate your numerical skills",
    },
    {
      title: "Reading Comprehension",
      description: "Passages and questions to assess your understanding",
    },
  ];

  useAnimationFrame(() => {
    if (!isPaused) {
      let current = x.get();
      x.set(current - SPEED);

      // total scroll width of one "loop"
      const totalWidth = testimonials.length * 420; // 400px card + 20px gap approx
      if (Math.abs(current) >= totalWidth) {
        x.set(0); // reset when fully scrolled
      }
    }
  });
  return (
    <>
      <Box
        className="landingscroll"
        sx={{
          backgroundColor: "white",
          height: "100vh",
          overflowY: "auto",
        }}
      >
        <AppBar
          position="sticky"
          sx={{
            top: 0,
            background: "#fff",
            boxShadow: "none",
            zIndex: 10,
            height: "auto",
            padding: "0px 60px",
            "@media (max-width:1024px)": {
              padding: "10px",
            },
            "@media (max-width:860px)": {
              padding: "0px",
            },
          }}
        >
          <Toolbar
            sx={{
              justifyContent: "space-between",
              padding: "0px 5%",
              width: "100%",
              minHeight: { xs: 60, sm: 70, md: 80, lg: 90 },
              paddingY: { xs: 0.5, sm: 1 },
              "@media (max-width:1024px)": {
                padding: "5px",
                padddingleft: "10px",
              },
            }}
          >
            {/* Logo */}
            <Typography
              variant="h6"
              sx={{
                color: "#228FD8",
                fontWeight: 600,
                display: "flex",
                // justifyContent: { xs: "center", md: "flex-start" },
                // width: { xs: "100%", md: "auto" },
                // position: { xs: "absolute", md: "static" },
                // left: { xs: 0, md: "auto" },
                // right: { xs: 0, md: "auto" },
                // top: { xs: 0, md: "auto" },
                // mx: { xs: "auto", md: 0 },
                zIndex: 2,
              }}
            >
              <SvgIcon
                component={MobileLoginLogo}
                inheritViewBox
                sx={{
                  height: "56px",
                  maxHeight: "64px",
                  width: "auto",
                  marginTop: "8px",
                  cursor: "pointer",
                  display: "block",
                  marginLeft: "10px",
                }}
                onClick={() => {
                  navigate("/");
                }}
              />
            </Typography>

            {/* Desktop Links */}
            <div style={{ display: "flex", gap: "10px" }}>
              <Box sx={{ display: { xs: "none", md: "flex" }, gap: 3 }}>
                <Button
                  sx={{
                    fontWeight: 600,
                    fontSize: "15px",
                    color: "#374151",
                    textTransform: "capitalize",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-5px)",
                    },
                  }}
                  onClick={() => scrollToElement("how-it-works")}
                >
                  How It Works
                </Button>
                <Button
                  sx={{
                    fontWeight: 600,
                    fontSize: "15px",
                    color: "#374151",
                    textTransform: "capitalize",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-5px)",
                    },
                  }}
                  onClick={() => scrollToElement("Pricing")}
                >
                  Pricing
                </Button>
                <Button
                  onClick={() => {
                    navigate("/login");
                  }}
                  sx={{
                    fontWeight: 600,
                    color: "#374151",
                    fontSize: "12px",
                    textTransform: "capitalize",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-5px)",
                    },
                  }}
                >
                  <LoginIcon sx={{ marginRight: "10px" }} /> Log in
                </Button>
              </Box>

              {/* CTA Button */}
              <Button
                variant="contained"
                sx={{
                  display: { xs: "none", md: "flex" },
                  backgroundColor: "#009DFF",
                  color: "#fff",
                  borderRadius: "12px",
                  fontWeight: 600,
                  padding: "12px 24px",
                  fontSize: "15px",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-5px)",
                    backgroundColor: "#009DFF",
                  },
                  textTransform: "capitalize",
                }}
                onClick={() => scrollToElement("Pricing")}
              >
                Start For Free
              </Button>
            </div>

            {/* Mobile Menu Icon */}
            <IconButton
              sx={{
                display: { xs: "flex", md: "none" },
                color: "black",
                zIndex: 3,
              }}
              onClick={() => setMobileMenuOpen(true)}
              aria-label="open menu"
            >
              <MenuIcon />
            </IconButton>

            {/* Mobile Drawer */}
            <Drawer
              anchor="top" // or "left" if you prefer
              open={mobileMenuOpen}
              onClose={() => setMobileMenuOpen(false)}
              PaperProps={{
                sx: {
                  position: "absolute",
                  left: 0,
                  right: 0,
                  width: "100%",
                  background: "#fff",
                  boxShadow: 3,
                  height: "auto",
                  maxWidth: "100vw",
                  maxHeight: "90vh",
                  overflow: "visible",
                  flexDirection: "column",
                  p: 0,
                  borderTopLeftRadius: 0,
                  borderTopRightRadius: 0,
                  borderBottomLeftRadius: 12,
                  borderBottomRightRadius: 12,
                  margin: 0,
                },
              }}
            >
              {/* Top Row: Logo + Close Icon */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  px: 2,
                  py: 2,
                  borderBottom: "1px solid #f0f0f0",
                  width: "100%",
                }}
              >
                <SvgIcon
                  component={MobileLoginLogo}
                  inheritViewBox
                  sx={{
                    height: 38,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setMobileMenuOpen(false);
                    navigate("/landingpage");
                  }}
                />
                <IconButton onClick={() => setMobileMenuOpen(false)}>
                  <CloseIcon />
                </IconButton>
              </Box>
              {/* Menu Items */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                  px: 2,
                  py: 2,
                  width: "100%",
                  alignItems: "flex-start",
                }}
              >
                <Button
                  fullWidth
                  onClick={() => {
                    setMobileMenuOpen(false);
                    scrollToElement("how-it-works");
                  }}
                  sx={{
                    justifyContent: "flex-start",
                    color: "#374151",
                    fontWeight: 600,
                    fontSize: "16px",
                    textTransform: "capitalize",
                  }}
                >
                  How It Works
                </Button>
                <Button
                  fullWidth
                  onClick={() => {
                    setMobileMenuOpen(false);
                    scrollToElement("Pricing");
                  }}
                  sx={{
                    justifyContent: "flex-start",
                    color: "#374151",
                    fontWeight: 600,
                    fontSize: "16px",
                    textTransform: "capitalize",
                  }}
                >
                  Pricing
                </Button>
                <Button
                  fullWidth
                  onClick={() => {
                    setMobileMenuOpen(false);
                    navigate("/login");
                  }}
                  sx={{
                    justifyContent: "flex-start",
                    color: "#374151",
                    fontWeight: 600,
                    fontSize: "16px",
                    textTransform: "capitalize",
                  }}
                >
                  <LoginIcon sx={{ marginRight: "10px" }} /> Log in
                </Button>
                <Button
                  fullWidth
                  variant="contained"
                  sx={{
                    mt: 2,
                    backgroundColor: "#009DFF",
                    color: "#fff",
                    borderRadius: "8px",
                    fontWeight: 600,
                    fontSize: "15px",
                    textTransform: "capitalize",
                  }}
                  onClick={() => {
                    setMobileMenuOpen(false);
                    navigate("/registration", { state: { path: "minimock" } });
                  }}
                >
                  Start For Free
                </Button>
              </Box>
            </Drawer>
          </Toolbar>
        </AppBar>
        {/* Hero Section */}
        <Box sx={{ margin: "0% 6% 6% 6%" }} data-aos="fade-up">
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: "center",
              gap: 4,
            }}
          >
            {/* Left Side - Image */}

            <Box sx={{ flex: 1 }}>
              <Grid sx={{ display: "flex", flexDirection: "column" }}>
                <Typography
                  variant="h5"
                  gutterBottom
                  sx={{
                    fontWeight: "bold",
                    fontFamily: "system-ui",
                    fontSize: {
                      xs: "36px", // small screens
                      sm: "37px", // tablets
                      md: "41px", // desktops
                      lg: "60px", // large screens
                    },
                    margin: "20px 0px 0px 0px",
                    background: "#009DFF",
                    backgroundSize: "1200% 1200%",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    animation: "rainbow-text-animation 6s ease infinite",
                    display: "inline-block",
                  }}
                >
                  WA's Most Powerful
                </Typography>{" "}
                <Typography
                  variant="h5"
                  gutterBottom
                  sx={{
                    fontWeight: "bold",
                    fontSize: {
                      xs: "36px", // small screens
                      sm: "36px", // tablets
                      md: "42px", // desktops
                      lg: "60px", // large screens
                    },
                    margin: "0px 0px 20px 0px",
                    background:
                      "linear-gradient(90deg, #8B5CF6, #D946EF, #F97316, #0EA5E9, #33C3F0, #8B5CF6)",
                    backgroundSize: "200% 200%",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    animation:
                      "rainbow-wave 2s linear infinite, wave-motion 2s ease-in-out infinite",
                    display: "inline-block",
                    lineHeight: {
                      xs: "normal", // Remove custom line height on xs
                      sm: "normal", // Keep for sm and up
                      md: "60px",
                      lg: "60px",
                    },
                    "@keyframes rainbow-wave": {
                      "0%": {
                        backgroundPosition: "0% 0%", // Start from the left
                      },
                      "100%": {
                        backgroundPosition: "200% 0%", // Move to the right
                      },
                    },
                  }}
                >
                  GATE/ASET <br />
                  AI Question Bank
                </Typography>
              </Grid>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  mb: 3,
                  fontSize: {
                    xs: "17px", // small screens
                    sm: "17px", // tablets
                    md: "19px", // desktops
                    lg: "20px", // large screens
                  },
                }}
              >
                Access over 2,000 expertly designed GATE-style questions with
                instant AI marking, feedback & help – built by WA 99+ ATAR
                Tutors
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  gap: 3,
                  flexDirection: { xs: "column", sm: "row" }, // Stack on small screens
                }}
              >
                <Button
                  variant="contained"
                  sx={{
                    fontSize: "16px",
                    display: "block",
                    background: "#009DFF",
                    px: 3,
                    py: 1,
                    color: "#fff",
                    fontWeight: "500",
                    textTransform: "capitalize",
                    borderRadius: "10px",
                    transition: "all 0.3s ease",

                    "&:hover": {
                      borderWidth: "2px",
                      border: "none",
                      backgroundColor: "#009dff",
                      color: "white",
                      borderRadius: "10px",
                      transform: "translateY(-5px)",
                    },
                  }}
                  onClick={() => {
                    navigate("/registration", { state: { path: "minimock" } });
                  }}
                >
                  Start For Free <br />
                  <div style={{ fontSize: "12px", color: "#B2E2FF" }}>
                    No credit card required
                  </div>
                </Button>

                <Button
                  variant="outlined"
                  size="large"
                  sx={{
                    fontSize: "16px",
                    px: 3,
                    py: 1,
                    borderRadius: "10px",
                    fontWeight: "500",
                    borderWidth: "2px",
                    backgroundColor: "white",
                    color: "#3a7bd5",
                    border: "1px solid #3a7bd5",
                    textTransform: "capitalize",
                    transition: "all 0.3s ease",
                    width: { xs: "100%", sm: "auto" }, // Full width on xs (<=600px)

                    "&:hover": {
                      borderWidth: "2px",
                      backgroundColor: "white",
                      borderRadius: "10px",
                      transform: "translateY(-5px)",
                    },
                  }}
                  onClick={() => scrollToElement("how-it-works")}
                >
                  See How It Works{" "}
                  <ArrowForwardIcon sx={{ marginLeft: "10px" }} />
                </Button>
              </Box>
            </Box>
            {/* Right Side - Content */}

            <Box
              className="gradient-card2"
              component="img"
              src={heroSection}
              alt="Performance Illustration"
              sx={{
                width: { xs: "100%", md: "45%" },
                height: "100%",
                borderRadius: 2,
                objectFit: "cover",
                marginTop: "10px",
              }}
            />
          </Box>
        </Box>

        <Box
          id="how-it-works"
          sx={{
            py: 6,
            textAlign: "center",
            backgroundColor: "#f7f9fc",
            margin: "0px 0px 0% 0%",
          }}
        >
          <Box
            component={motion.div}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.6 }}
            sx={{
              margin: {
                xs: "10% 5% 3% 5%",
                sm: "5% 5% 3% 5%",
                md: "3% 5% 3% 5%",
                lg: "3% 5% 3% 5%",
              },
            }}
          >
            <Typography
              variant="h3"
              fontWeight={700}
              gutterBottom
              sx={{
                fontSize: {
                  xs: "30px", // mobile
                  sm: "30px", // tablet
                  md: "36px", // desktop
                  lg: "36px", // large screens
                },
                lineHeight: "40px",
                textAlign: "center",
                mb: 2,
              }}
            >
              How Our GATE/ASET AI Question Bank Transforms Your Preparation
            </Typography>
            <Typography
              variant="subtitle1"
              color="text.secondary"
              mb={5}
              sx={{
                fontSize: {
                  xs: "17px", // small screens
                  sm: "17px", // tablets
                  md: "18px", // desktops
                  lg: "18px", // large screens
                },
              }}
            >
              Our step-by-step approach helps you systematically improve your
              GATE performance
            </Typography>

            <Grid container spacing={2} justifyContent="center">
              {steps.map((step, index) => (
                <Grid item xs={12} sm={12} md={6} lg={3} key={index}>
                  <motion.div
                    whileHover={{ y: -0.5 }}
                    transition={{
                      type: "tween",
                      duration: 0.35, // 350ms
                      ease: "easeInOut",
                    }}
                  >
                    <Box
                      className="gradientline-card"
                      sx={{
                        borderRadius: 3,
                        padding: "5px",
                        // border: "1px solid transparent",
                        // background: step.border,
                      }}
                    >
                      <Paper
                        elevation={0}
                        sx={{
                          height: "22rem",
                          p: 3,
                          borderRadius: "7px",
                          background: "#fff",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          gap: 2,
                        }}
                      >
                        <div style={{ display: "flex", gap: "10px" }}>
                          <Box
                            sx={{
                              background: "#007FFF",
                              color: "white",
                              borderRadius: "50%",
                              width: 40,
                              height: 40,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontWeight: 700,
                              fontSize: "1.1rem",
                            }}
                          >
                            {index + 1}
                          </Box>
                          <Box
                            sx={{
                              background: "#e3f2fd",
                              color: "white",
                              borderRadius: "50%",
                              width: 40,
                              height: 40,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontWeight: 700,
                              fontSize: "1.2rem",
                            }}
                          >
                            {step?.icon}
                          </Box>
                        </div>
                        <Typography
                          variant="h5"
                          fontSize="20px"
                          sx={{ textAlign: "left" }}
                          fontWeight={600}
                        >
                          {step.title}
                        </Typography>
                        <Tooltip title={step.description}>
                          <Typography
                            variant="body2"
                            fontSize="14px"
                            color="text.secondary"
                            sx={{
                              textAlign: "left",
                              display: "-webkit-box",
                              WebkitLineClamp: 3,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              fontSize: {
                                xs: "15px", // small screens
                                sm: "15px", // tablets
                                md: "16px", // desktops
                                lg: "16px", // large screens
                              },
                            }}
                          >
                            {step.description}
                          </Typography>
                        </Tooltip>
                      </Paper>
                    </Box>
                  </motion.div>
                </Grid>
              ))}
            </Grid>

            {/* Bottom Note */}
            <Box
              mt={6}
              mx="auto"
              sx={{
                maxWidth: 630,
                px: 3,
                py: 2,
                borderRadius: 2,
                backgroundColor: "#d2ecff73",
              }}
              // data-aos="fade-up"
            >
              <Typography
                variant="subtitle1"
                color="primary"
                sx={{ fontSize: "16px", fontWeight: 600 }}
              >
                Our AI-powered platform is designed for serious students who
                want to maximize their preparation time with immediate,
                personalised feedback and strategic improvement suggestions.
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.6 }}
          sx={{
            margin: {
              xs: "10% 12% 5% 12%",
              sm: "5% 12% 5% 12%",
              md: "3% 12% 5% 12%",
              lg: "3% 12% 5% 12%",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: "center",
              gap: 4,
            }}
          >
            {/* Left Side - Image */}

            <Box sx={{ flex: 1 }}>
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 1,
                  px: 2,
                  py: 1,
                  backgroundColor: "#E8F6FF", // light blue
                  color: "#1E90FF", // blue text/icon
                  borderRadius: "999px", // pill shape
                  fontWeight: 500,
                  fontSize: "0.874rem",
                  cursor: "pointer",
                }}
              >
                <img
                  src={playLogo}
                  alt="AI Robot Scene"
                  style={{ width: "18px" }}
                />
                <Typography
                  variant="body2"
                  sx={{ color: "#009DFF", fontWeight: 600, fontSize: "14px" }}
                >
                  Watch It Happen Before Your Eyes
                </Typography>
              </Box>
              <Typography
                gutterBottom
                sx={{
                  fontWeight: "bold",
                  fontSize: "34px",
                  margin: "20px 0px",
                }}
              >
                See It In Action!
              </Typography>

              <Typography
                variant="body1"
                paragraph
                color="#4B5563"
                sx={{
                  mb: 3,
                  fontSize: {
                    xs: "16px",
                    sm: "16px",
                    md: "17px",
                    lg: "17px",
                  },
                }}
              >
                Watch how our Writing AI Tool marks your writing, corrects your
                errors, rewrites your text for you & gives you an exemplar
                answer!
              </Typography>

              <List
                sx={{
                  padding: "20px",
                  borderRadius: "10px",
                  margin: "21px 0px 40px",
                  boxShadow:
                    "0 0px 1px 0 rgba(0, 0, 0, 0.2),0 4px 11px 0 rgba(0, 0, 0, 0.19)",
                }}
              >
                <ListItem disablePadding sx={{ mb: 1, gap: "10px" }}>
                  <Box
                    sx={{
                      background: "#e3f2fd",
                      color: "#007FFF",
                      borderRadius: "50%",
                      minWidth: 40,
                      height: 40,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 700,
                      fontSize: "1.2rem",
                    }}
                  >
                    1
                  </Box>
                  <div>
                    <ListItemText
                      primary={"Written Text Submitted"}
                      sx={{
                        "& .MuiListItemText-primary": {
                          fontSize: "16px",
                          fontWeight: 600,
                        },
                      }}
                    />
                    <div
                      style={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "16px" }}
                    >
                      Writing Analysed & Marked
                    </div>
                  </div>
                </ListItem>
                <ListItem disablePadding sx={{ mb: 1, gap: "10px" }}>
                  <Box
                    sx={{
                      background: "#e3f2fd",
                      color: "#007FFF",
                      borderRadius: "50%",
                      minWidth: 40,
                      height: 40,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 700,
                      fontSize: "1.2rem",
                    }}
                  >
                    2
                  </Box>
                  <div>
                    <ListItemText
                      primary={"AI Feedback"}
                      sx={{
                        "& .MuiListItemText-primary": {
                          fontSize: "16px",
                          fontWeight: 600,
                        },
                      }}
                    />
                    <div
                      style={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "16px" }}
                    >
                      Mistakes & Improvements identified
                    </div>
                  </div>
                </ListItem>
                <ListItem disablePadding sx={{ mb: 1, gap: "10px" }}>
                  <Box
                    sx={{
                      background: "#e3f2fd",
                      color: "#007FFF",
                      borderRadius: "50%",
                      minWidth: 40,
                      height: 40,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 700,
                      fontSize: "1.2rem",
                      gap: "10px",
                    }}
                  >
                    3
                  </Box>
                  <div>
                    <ListItemText
                      primary={"AI Rewritten Text & Exemplar Text"}
                      sx={{
                        "& .MuiListItemText-primary": {
                          fontSize: "16px",
                          fontWeight: 600,
                        },
                      }}
                    />
                    <div
                      style={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "16px" }}
                    >
                      View your own text rewritten & how an expert writes a
                      response!
                    </div>
                  </div>
                </ListItem>
              </List>

              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 1,
                  px: 2,
                  py: 1.2,
                  border: "1px solid #FFE9B5", // light yellow border
                  borderRadius: "12px", // rounded box
                  color: "#8B4513", // dark brown text
                  backgroundColor: "#FFFBEB", // light blue
                  fontWeight: 600,
                  width: "100%",
                }}
              >
                <img
                  src={playbutton}
                  alt="AI Robot Scene"
                  style={{ width: "18px" }}
                />
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 600,
                    fontSize: "14px",
                    color: "#8B4513",
                  }}
                >
                  Created by our team of expert writers and educators.
                </Typography>
              </Box>
            </Box>
            {/* Right Side - Content */}

            <Box
              sx={{
                width: { xs: "100%", md: "45%" },
                height: "100%",
                borderRadius: 2,
                objectFit: "cover",
              }}
            >
              <Box
                sx={{
                  height: "26rem",
                  width: "100%",
                  justifyContent: "center",
                  backgroundColor: "#0f172a",
                  borderRadius: "10px",
                }}
                className="gradientline-card"
              >
                <Box
                  sx={{
                    width: "100%",
                    borderRadius: "10px",
                    position: "relative",
                    cursor: "pointer",
                    height: "100%",
                    backgroundColor: "#0f172a",
                  }}
                >
                  {/* Play Button */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      bgcolor: "#228FD8",
                      color: "white",
                      borderRadius: "50%",
                      width: 60,
                      height: 60,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: 4,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        bgcolor: "#1a6fb8",
                        transform: "translate(-50%, -50%) scale(1.1)",
                      },
                    }}
                  >
                    <PlayArrowIcon sx={{ fontSize: 35 }} onClick={handleOpen} />
                  </Box>
                  <div
                    style={{
                      color: "white",
                      fontWeight: 600,
                      fontSize: "15px",
                      textAlign: "center",
                      paddingTop: "200px",
                    }}
                  >
                    Watch Demo Video
                  </div>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* image and concent  */}
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.6 }}
          sx={{
            margin: {
              xs: "10% 5% 5% 5%",
              sm: "5% 5% 5% 5%",
              md: "3% 5% 5% 5%",
              lg: "3% 5% 5% 5%",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: "center",
              gap: "60px",
            }}
          >
            {/* Left Side - 2x2 Image Grid */}
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                gap: 2,
                width: { xs: "100%", md: "50%" },
                marginTop: "40px",
              }}
            >
              {[
                abstractReasoning,
                writingTest,
                readingcomprehension,
                quantitativeReasoning,
              ].map((src, idx) => (
                <Box
                  key={idx}
                  sx={{
                    position: "relative",
                    width: "100%",
                    overflow: "visible", // allow the info-box to appear outside
                    transition: "all 0.3s ease",
                    "&:hover .info-box": {
                      opacity: 1,
                      // transform: "translateY(0)",
                      pointerEvents: "auto",
                      transform: "translateY(-5px)",
                    },
                  }}
                >
                  {/* Image */}
                  <motion.div whileHover={{ scale: 1.05 }}>
                    <Box
                      component="img"
                      src={src}
                      alt={`Preview ${idx + 1}`}
                      sx={{
                        width: "100%",
                        height: "168px",
                        objectFit: "cover",
                        borderRadius: "10px",
                        padding: "4px",
                        background:
                          "linear-gradient(90deg, #8B5CF6, #D946EF, #F97316, #0EA5E9, #33C3F0, #8B5CF6) border-box",
                        backgroundSize: "400% 100%",
                        animation: "rainbowBorders 6s linear infinite",
                        margin: "10px",
                        boxShadow:
                          "0 10px 10px 0 rgba(0, 0, 0, 0.2)" /* Adds a shadow on hover */,
                      }}
                    />
                  </motion.div>
                  {/* Info Box (appears below image on hover) */}
                  <Box
                    className="info-box"
                    sx={{
                      position: "absolute",
                      top: "100%", // directly below the image
                      left: "10%",
                      transform: "translate(-50%, 10px)", // initial offset down
                      backgroundColor: "white",
                      padding: 2,
                      borderRadius: "10px",
                      boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                      opacity: 0,
                      transition: "all 0.3s ease-in-out",
                      pointerEvents: "none",
                      minWidth: "80%", // or fixed width like "300px"
                      textAlign: "left",
                      zIndex: 1,
                    }}
                  >
                    <h3 style={{ margin: "0 0 4px 0", fontSize: "1.3rem" }}>
                      {cardContent[idx].title}
                    </h3>
                    <p style={{ margin: 0, fontSize: "1.1rem", color: "#555" }}>
                      {cardContent[idx].description}
                    </p>
                  </Box>
                </Box>
              ))}
            </Box>

            {/* Right Side - Content */}
            <Box sx={{ flex: 1, margin: "1% 0 0 0" }}>
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 1,
                  px: 2,
                  py: 1,
                  backgroundColor: "#E8F6FF", // light blue
                  color: "#1E90FF", // blue text/icon
                  borderRadius: "999px", // pill shape
                  fontWeight: 500,
                  fontSize: "0.875rem",
                  cursor: "pointer",
                }}
              >
                <img
                  src={brainbutton}
                  alt="AI Robot Scene"
                  style={{ width: "18px" }}
                />
                <Typography
                  variant="body2"
                  sx={{ color: "#009DFF", fontWeight: 600, fontSize: "14px" }}
                >
                  AI-Powered Practice That Accelerates Growth
                </Typography>
              </Box>
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  fontWeight: "bold",
                  fontSize: "31px",
                  margin: "20px 0px",
                }}
              >
                Smart Practice, Real Results
              </Typography>

              <Typography
                variant="body1"
                paragraph
                color="#4B5563"
                sx={{ mb: 3, fontSize: "18px" }}
              >
                Access our advanced GATE-style question bank — enhanced with
                instant AI feedback, curated by 99+ ATAR WA graduates. Practice
                smarter with real-time marking and explanations.
              </Typography>

              <List>
                {items.map((item, index) => (
                  <ListItem key={index} disablePadding sx={{ mb: 1 }}>
                    <ListItemIcon sx={{ minWidth: 36 }}>
                      <CheckCircleOutlineIcon
                        sx={{ color: "#009EFF", fontSize: 20 }} // adjust size as needed
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={item.text}
                      sx={{
                        "& .MuiListItemText-primary": {
                          fontSize: "15px",
                          color: "#374151",
                        },
                      }}
                    />
                  </ListItem>
                ))}
              </List>

              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 1,
                  px: 2,
                  py: 1.2,
                  backgroundColor: "#E8F6FF", // light blue
                  color: "#1E90FF", // blue text/icon
                  borderRadius: "12px", // rounded box
                  fontWeight: 600,
                  width: "100%",
                }}
              >
                <img
                  src={targetbutton}
                  alt="AI Robot Scene"
                  style={{ width: "18px" }}
                />
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 400,
                    fontSize: "14px",
                    color: "#1e40af", // blue text/icon
                    padding: "5px",
                  }}
                >
                  <b
                    style={{
                      color: "#1e40af",
                      fontSize: "15px",
                      fontWeight: 500,
                    }}
                  >
                    Bonus
                  </b>
                  : Get feedback within seconds — no manual marking required.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.6 }}
          sx={{
            margin: {
              xs: "10% 5% 5% 5%",
              sm: "5% 5% 5% 5%",
              md: "3% 5% 5% 5%",
              lg: "3% 5% 5% 5%",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: "center",
              gap: 4,
            }}
          >
            {/* Left Side - Image */}

            <Box
              sx={{
                flex: 1,
                margin: {
                  xs: "30% 0% 0% 0%",
                  sm: "12% 0% 0% 0%",
                  md: "3% 0% 0% 0%",
                  lg: "3% 0% 0% 0%",
                },
              }}
            >
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 1,
                  px: 2,
                  py: 1,
                  backgroundColor: "#E8F6FF", // light blue
                  color: "#1E90FF", // blue text/icon
                  borderRadius: "999px", // pill shape
                  fontWeight: 500,
                  fontSize: "0.875rem",
                  cursor: "pointer",
                }}
              >
                <img
                  src={targetbutton}
                  alt="AI Robot Scene"
                  style={{ width: "18px" }}
                />
                <Typography
                  variant="body2"
                  sx={{ color: "#1E90FF", fontWeight: 600, fontSize: "14px" }}
                >
                  Train Like It's the Real Exam
                </Typography>
              </Box>
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  fontWeight: "bold",
                  fontSize: "31px",
                  margin: "20px 0px",
                }}
              >
                Realistic Exam Simulation
              </Typography>

              <Typography
                variant="body1"
                paragraph
                color="#4B5563"
                sx={{ mb: 3, fontSize: "19px" }}
              >
                Experience the GATE exam environment with timed mock tests built
                to reflect real difficulty, structure, and pacing. After every
                attempt, receive detailed performance insights to guide your
                next step.
              </Typography>

              <List>
                {itemLanding.map((item, index) => (
                  <ListItem key={index} disablePadding sx={{ mb: 1 }}>
                    <ListItemIcon sx={{ minWidth: 36 }}>
                      <CheckCircleOutlineIcon
                        sx={{ color: "#009EFF", fontSize: 19 }} // adjust size as needed
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={item.text}
                      sx={{
                        "& .MuiListItemText-primary": {
                          fontSize: "16px",
                          color: "#374151",
                        },
                      }}
                    />
                  </ListItem>
                ))}
              </List>

              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 1,
                  px: 2,
                  py: 1.2,
                  backgroundColor: "#E8F6FF", // light blue
                  color: "#1E90FF", // blue text/icon
                  borderRadius: "12px", // rounded box
                  fontWeight: 600,
                }}
              >
                <img
                  src={targetbutton}
                  alt="AI Robot Scene"
                  style={{ width: "18px" }}
                />
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 400,
                    fontSize: "14px",
                    color: "#1e40af", // blue text/icon
                    padding: "5px",
                  }}
                >
                  <b
                    style={{
                      color: "#1e40af",
                      fontSize: "15px",
                      fontWeight: 500,
                    }}
                  >
                    Bonus
                  </b>
                  : Get feedback within seconds — no manual marking required.
                </Typography>
              </Box>
            </Box>
            {/* Right Side - Content */}

            <Box
              className="line-card"
              component="img"
              src={examSimulation} // <-- Replace with your image path
              alt="Performance Illustration"
              sx={{
                width: { xs: "100%", md: "45%" },
                height: "100%",
                borderRadius: 2,
                objectFit: "cover",
              }}
            />
          </Box>
        </Box>
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.6 }}
          sx={{
            margin: {
              xs: "10% 5% 5% 5%",
              sm: "5% 5% 5% 5%",
              md: "3% 5% 5% 5%",
              lg: "3% 5% 5% 5%",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: "center",
              gap: 4,
            }}
          >
            {/* Left Side - Image */}
            <Box
              className="line-card"
              component="img"
              src={performanceEnhancement} // <-- Replace with your image path
              alt="Performance Illustration"
              sx={{
                width: { xs: "100%", md: "45%" },
                height: "100%",
                borderRadius: 2,
                objectFit: "cover",
              }}
            />

            {/* Right Side - Content */}
            <Box sx={{ flex: 1 }}>
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 1,
                  px: 2,
                  py: 1,
                  backgroundColor: "#E8F6FF", // light blue
                  color: "#1E90FF", // blue text/icon
                  borderRadius: "999px", // pill shape
                  fontWeight: 500,
                  fontSize: "0.875rem",
                  cursor: "pointer",
                }}
              >
                <img
                  src={tradebuttoncolor}
                  alt="AI Robot Scene"
                  style={{ width: "18px" }}
                />

                <Typography
                  variant="body2"
                  sx={{ color: "#1E90FF", fontWeight: 600, fontSize: "14px" }}
                >
                  Sharpen the Skills That Matter Most
                </Typography>
              </Box>
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  fontWeight: "bold",
                  fontSize: "31px",
                  margin: "20px 0px",
                }}
              >
                Performance Enhancement
              </Typography>

              <Typography
                variant="body1"
                paragraph
                color="text.secondary"
                sx={{ mb: 3, fontSize: "18px" }}
              >
                Target the core abilities tested in GATE exams — memory,
                reasoning, focus, speed. Our skill-building mini modules are
                designed to help students build accuracy under pressure, one
                drill at a time.
              </Typography>

              <List>
                {itemLandingpaddig.map((item, index) => (
                  <ListItem key={index} disablePadding sx={{ mb: 1 }}>
                    <ListItemIcon sx={{ minWidth: 36 }}>
                      <CheckCircleOutlineIcon
                        sx={{ color: "#009EFF", fontSize: 20 }} // adjust size as needed
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={item.text}
                      sx={{
                        "& .MuiListItemText-primary": {
                          fontSize: "15px",
                        },
                      }}
                    />
                  </ListItem>
                ))}
              </List>

              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 1,
                  px: 2,
                  py: 1.2,
                  backgroundColor: "#FFFBF2", // soft yellow background
                  border: "1px solid #FFE9B5", // light yellow border
                  borderRadius: "12px", // rounded box
                  color: "#8B4513", // dark brown text
                  fontWeight: 600,
                  width: "100%",
                }}
              >
                <img
                  src={brainbuttoncolor}
                  alt="AI Robot Scene"
                  style={{ width: "18px" }}
                />
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 600,
                    fontSize: "15px",
                    color: "#8B4513",
                    padding: "5px",
                  }}
                >
                  Developed by GATE top scorers and 99+ ATAR WA Tutors.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* Platform Features */}
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.6 }}
          sx={{
            margin: {
              xs: "10% 5% 5% 5%",
              sm: "5% 5% 5% 5%",
              md: "3% 5% 5% 5%",
              lg: "3% 5% 5% 5%",
            },
            textAlign: "center",
          }}
        >
          <Typography
            variant="h3"
            component="h1"
            sx={{
              fontWeight: "bold",
              mb: 2,
              fontSize: "31px",
            }}
          >
            Built for Students Who Want an Edge
          </Typography>

          <Typography
            variant="h5"
            component="p"
            color="text.secondary"
            sx={{
              mb: 6,
              maxWidth: "700px",
              mx: "auto",
              fontSize: "19px",
            }}
          >
            Our platform is designed with features that make a real difference
            in your GATE preparation.
          </Typography>

          {/* Top 3 Boxes */}
          <Grid container spacing={3} sx={{ mb: 6, justifyContent: "center" }}>
            {topFeatures.map((feature, index) => (
              <Grid item xs={12} sm={12} md={4} key={`top-${index}`}>
                <Box className="line-card" sx={{ height: "100%" }}>
                  <Paper
                    elevation={0}
                    sx={{
                      borderRadius: "10px",
                      padding: "20px 16px",
                      height: "100%",
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 2,
                      boxShadow: "0 2px 8px 0 rgba(0,0,0,0.04)",
                      transition: "box-shadow 0.2s",
                      "&:hover": {
                        boxShadow: "0 4px 16px 0 rgba(0,0,0,0.10)",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        color: "#009DFF",
                        backgroundColor: "#E8F6FF",
                        borderRadius: "50%",
                        width: 44,
                        height: 44,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mr: 2,
                        mt: 0.5,
                        flexShrink: 0,
                      }}
                    >
                      {feature.icon}
                    </Box>
                    <Box>
                      <Typography
                        component="h3"
                        sx={{
                          fontWeight: 700,
                          mb: 0.5,
                          textAlign: "left",
                          fontSize: "16px",
                          color: "#009DFF",
                        }}
                      >
                        {feature.title}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                          textAlign: "left",
                          fontSize: "14px",
                          color: "#374151",
                        }}
                      >
                        {feature.description}
                      </Typography>
                    </Box>
                  </Paper>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Pricing Section */}
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.6 }}
          id="Pricing"
          sx={{
            py: 8,
            background: "#009DFF",
            color: "white",
          }}
        >
          <Container maxWidth="lg">
            <Typography
              variant="h3"
              component="h2"
              sx={{
                textAlign: "center",
                mb: 2,
                fontSize: "30px",
                fontWeight: "bold",
              }}
            >
              Start Free. Upgrade Anytime.
            </Typography>
            <Typography
              variant="h5"
              sx={{
                textAlign: "center",
                mb: 6,
                color: "white",
              }}
            >
              Choose the plan that works best for your preparation needs
            </Typography>

            <Grid container spacing={4} justifyContent="center">
              {pricingPlans.map((plan, index) => (
                <Grid item xs={12} md={5} key={index}>
                  <div
                    className={`card-container ${
                      plan.isRecommended ? "line-cards" : "line"
                    }`}
                    style={{
                      height: "100%",
                      width: "100%", // Ensure full width
                      // maxWidth: 400, // Optional: limit max width on large screens
                      // margin: "0 auto", // Center on mobile
                    }}
                  >
                    <Card
                      className="card-container"
                      style={{
                        height: "100%",
                        width: "100%",
                        boxSizing: "border-box",
                      }}
                    >
                      {plan.isRecommended && (
                        <Box
                          sx={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                            background:
                              "linear-gradient(135deg, #3b82f6  0%, #9333ea 100%)",
                            color: "white",
                            px: 2,
                            py: 1,
                            fontSize: "1rem",
                            fontWeight: "bold",
                            borderBottomLeftRadius: "8px",
                          }}
                        >
                          RECOMMENDED
                        </Box>
                      )}

                      <Typography
                        variant="h5"
                        component="h3"
                        sx={{
                          fontWeight: "bold",

                          fontSize: "2.3rem",
                          color: "black",
                        }}
                      >
                        {plan.name}
                      </Typography>
                      <Typography
                        variant="h4"
                        sx={{
                          fontWeight: "bold",
                          fontSize: "4rem",
                          color: "black",
                        }}
                      >
                        {plan.price}{" "}
                        <Typography
                          component="span"
                          variant="body2"
                          color="text.secondary"
                          sx={{ fontSize: "17px" }}
                        >
                          {plan.billingCycle}
                        </Typography>
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          mb: 2,
                          color: "text.secondary",
                          fontSize: "17px",
                        }}
                      >
                        {plan.description}
                      </Typography>
                      <Divider variant="middle" />
                      <Box sx={{ mb: 4, mt: 2 }}>
                        <Typography
                          variant="h5"
                          sx={{
                            fontWeight: 500,
                            color: "black",
                            fontSize: "15px",
                            marginBottom: "10px",
                          }}
                        >
                          What's included:
                        </Typography>
                        <List dense sx={{ height: "15rem" }}>
                          {plan.features.map((feature, featureIndex) => (
                            <ListItem
                              disablePadding
                              key={featureIndex}
                              sx={{ marginBottom: "10px" }}
                            >
                              <ListItemIcon sx={{ minWidth: "30px" }}>
                                <CheckIcon sx={{ color: "green" }} />
                              </ListItemIcon>
                              <Typography
                                sx={{ color: "black", fontSize: "16px" }}
                              >
                                {feature}
                              </Typography>
                            </ListItem>
                          ))}
                          {plan.disabledFeatures &&
                            plan.disabledFeatures.map(
                              (feature, featureIndex) => (
                                <ListItem
                                  disablePadding
                                  sx={{ marginBottom: "10px" }}
                                  key={`disabled-${featureIndex}`}
                                >
                                  <ListItemIcon sx={{ minWidth: "30px" }}>
                                    <Box sx={{ color: "error.main", mr: 1 }}>
                                      x
                                    </Box>
                                  </ListItemIcon>
                                  <Typography
                                    sx={{
                                      color: "text.disabled",
                                      fontSize: "17px",
                                    }}
                                  >
                                    {feature}
                                  </Typography>
                                </ListItem>
                              )
                            )}
                        </List>
                      </Box>
                      <Button
                        variant="contained"
                        color="secondary"
                        size="large"
                        sx={{
                          fontSize: "1.2rem",
                          background: plan.isRecommended
                            ? "linear-gradient(135deg, #3b82f6  0%, #9333ea 100%)"
                            : "#009DFF",
                          color: "white",
                          px: 4,
                          py: 2,
                          fontWeight: "bold",
                          textTransform: "capitalize",
                          borderRadius: "10px",
                          transition: "all 0.3s ease",
                          width: { xs: "100%", sm: "auto" },
                          mt: {
                            xs: 17, // small screens
                            sm: 10, // tablets
                            md: 8, // desktops
                            lg: 4, // large screens
                          }, // margin top for spacing
                          "&:hover": {
                            transform: "translateY(-5px)",
                            background: plan.isRecommended
                              ? "linear-gradient(135deg, #3b82f6  0%, #9333ea 100%)"
                              : "#009DFF",
                            color: "white",
                          },
                        }}
                        onClick={() => {
                          if (plan.isRecommended) {
                            navigate("/registration", {
                              state: { path: "totalexam" },
                            });
                          } else {
                            navigate("/registration", {
                              state: { path: "minimock" },
                            });
                          }
                        }}
                      >
                        {plan.buttonText}
                      </Button>
                    </Card>
                  </div>
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>

        {/* tab  */}
        <Box
          sx={{ padding: "3%", bgcolor: "#F8F9FA" }}
          component={motion.div}
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.6 }}
        >
          {" "}
          {/* Optional background color */}
          <Box sx={{ margin: "7% 10%" }}>
            <Grid container spacing={4} justifyContent="space-around">
              {featureslist?.map((item, index) => (
                <Grid item xs={12} sm={12} md={3} key={index}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      fontSize: { xs: "16px", sm: "17px", md: "18px" }, // responsive font size
                    }}
                  >
                    <Box
                      sx={{
                        width: 48,
                        height: 48,
                        minWidth: 48,
                        minHeight: 48,
                        borderRadius: "50%",
                        backgroundColor: "#009dff1a",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mr: 2,
                        fontSize: "23px", // icon size inside the circle
                        color: "#009dff",
                        overflow: "hidden",
                      }}
                    >
                      {item.icon}
                    </Box>

                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: "15px",
                        textAlign: "left",
                        fontWeight: 500,
                        color: "#374151",
                      }}
                    >
                      {item.title}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
        {/* Testimonials */}
        <Box
          sx={{
            py: 8,
            position: "relative", // For positioning the arrows
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
          component={motion.div}
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.6 }}
        >
          <Box sx={{ width: "90%", margin: "0 auto" }}>
            <Typography
              variant="h3"
              component="h2"
              sx={{
                textAlign: "center",
                mb: 3,
                fontWeight: "700",
                fontSize: "36px",
              }}
            >
              Students & Parents Love Everest Tutoring
            </Typography>
            <Typography
              variant="h5"
              sx={{
                textAlign: "center",
                mb: 8,
                color: "#4B5563",
              }}
            >
              See what our community has to say about their experience
            </Typography>

            <Box
              ref={scrollRef}
              sx={{
                display: "flex",
                gap: 4,
                overflowX: "auto",
                flexWrap: "nowrap",
                scrollSnapType: "x mandatory",
                WebkitOverflowScrolling: "touch",
                scrollBehavior: "smooth",
                mb: 4,
              }}
              // onMouseEnter={() => controls.stop()} // stop scrolling on hover
              // onMouseLeave={() =>
              //   controls.start({
              //     x: ["0%", "-100%"],
              //     // transition: {
              //     //   ease: "linear",
              //     //   duration: 50,
              //     //   repeat: Infinity,
              //     // },
              //   })
              // }
            >
              <motion.div
                style={{
                  display: "flex",
                  gap: "1.5rem",
                  padding: "16px",
                  x,
                }}
                onMouseEnter={() => setIsPaused(true)}
                onMouseLeave={() => setIsPaused(false)}
              >
                {[...testimonials, ...testimonials].map(
                  (testimonial, index) => (
                    <Card
                      key={testimonial.name}
                      sx={{
                        scrollSnapAlign: "start",
                        flex: "0 0 auto",
                        width: {
                          xs: "90vw",
                          sm: "70vw",
                          md: "45.33%",
                          lg: "33.33%",
                        },
                        minWidth: 0,
                        maxWidth: 320,
                        p: 0,
                        height: "100%",
                        boxShadow: 3,
                        borderRadius: "16px",
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                        margin: "0px auto",
                        "&:hover": {
                          transform: "scale(1.01)",
                          marginTop: "-5px",
                        },
                      }}
                      // sx={{
                      //   flex: "0 0 26.66%", // 3 full cards inside 80% space
                      //   scrollSnapAlign: "start",
                      //   boxShadow: 3,
                      //   borderRadius: "16px",
                      //   display: "flex",
                      //   flexDirection: "column",
                      //   overflow: "hidden",
                      //   height: "100%",
                      // }}
                    >
                      <Box
                        sx={{
                          p: "24px",
                          transition:
                            "transform 1s ease-in-out, opacity 1s ease-in-out",
                          // "&:hover": {
                          //   transform: "scale(1.03)",
                          //   opacity: 1,

                          // },
                        }}
                      >
                        <div style={{ height: "11rem" }}>
                          <Box sx={{ display: "flex", mb: 1 }}>
                            {[1, 2, 3, 4, 5].map((star) => (
                              <StarIcon
                                key={star}
                                sx={{ color: "#ffcc14", fontSize: "23px" }}
                              />
                            ))}
                          </Box>
                          <Typography
                            variant="body1"
                            sx={{
                              fontStyle: "italic",
                              mb: 3,
                              flexGrow: 1,
                              fontSize: "14px",
                              color: "#374151",
                            }}
                          >
                            "{testimonial.quote}"
                          </Typography>
                        </div>
                        <Box>
                          <Box
                            sx={{
                              display: "flex",
                              fontSize: { xs: "14px", sm: "17px", md: "18px" },
                            }}
                          >
                            <Box
                              sx={{
                                width: 42,
                                height: 42,
                                minWidth: 42,
                                minHeight: 42,
                                borderRadius: "50%",
                                fontWeight: 700,
                                backgroundColor: "#009dff1a",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                mr: 2,
                                fontSize: "16px",
                                color: "#009dff",
                                overflow: "hidden",
                                textTransform: "capitalize",
                              }}
                            >
                              {testimonial.name.slice(0, 1)}
                            </Box>
                            <div>
                              <Typography
                                variant="h5"
                                sx={{ fontWeight: "600", fontSize: "14px" }}
                              >
                                {testimonial.name}
                              </Typography>

                              <Typography
                                variant="h6"
                                color="#6B7280"
                                sx={{ fontSize: "12px ", fontWeight: "400" }}
                              >
                                {testimonial.role}
                              </Typography>
                            </div>
                          </Box>
                        </Box>
                      </Box>
                    </Card>
                  )
                )}
              </motion.div>
            </Box>

            {/* <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: 2,
              }}
            >
              <IconButton
                sx={{ backgroundColor: "white", border: "1px solid #e2e8f0" }}
                onClick={goToPrevious}
                aria-label="previous testimonial"
              >
                <ArrowBackIcon fontSize="small" sx={{ color: "black" }} />
              </IconButton>
              <IconButton
                sx={{ backgroundColor: "white", border: "1px solid #e2e8f0" }}
                onClick={goToNext}
                aria-label="next testimonial"
              >
                <ArrowForwardIcon fontSize="small" sx={{ color: "black" }} />
              </IconButton>
            </Box> */}
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                marginTop: "40px",
              }}
            >
              <Button
                variant="contained"
                color="secondary"
                size="large"
                sx={{
                  fontSize: "1.2rem",
                  background: "#009dff",
                  px: 4,
                  color: "#fff",
                  py: 2,
                  fontWeight: "bold",
                  textTransform: "capitalize",
                  borderRadius: "10px",
                  transition: "all 0.3s ease", // Smooth transition
                  width: { xs: "100%", sm: "auto" }, // 100% width on small screens

                  "&:hover": {
                    transform: "translateY(-5px)", // Move up
                    borderWidth: "2px",
                    border: "none",
                    backgroundColor: "#009dff",
                    color: "white",
                    borderRadius: "10px",
                  },
                }}
                onClick={() => scrollToElement("Pricing")}
              >
                Join Our Growing Community
              </Button>
            </div>
          </Box>
        </Box>

        {/* FAQ Section */}
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.6 }}
        >
          <Box sx={{ margin: "5% 10% 5% 10%" }}>
            <Typography
              variant="h3"
              component="h2"
              sx={{
                textAlign: "center",
                fontWeight: "700",
                marginBottom: "10px",
                fontSize: "36px",
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Typography
              variant="h4"
              color="text.secondary"
              sx={{
                textAlign: "center",
                mb: 8,

                fontSize: "17px",
              }}
            >
              Get answers to common questions about our platform
            </Typography>
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              {faqData?.map((item, index) => (
                <Accordion
                  key={index}
                  disableGutters
                  sx={{
                    boxShadow: "none",
                    width: { xs: "100%", sm: "100%", md: "60%", lg: "100%" }, // 100% width on small screens
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`panel${index + 1}-content`}
                    id={`panel${index + 1}-header`}
                  >
                    <Typography sx={{ fontWeight: 500, fontSize: "16px" }}>
                      {item.question}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography
                      color="text.secondary"
                      sx={{ fontSize: "14px" }}
                    >
                      {item.answer}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              ))}
            </div>
          </Box>
        </Box>

        {/* CTA Section */}
        <Box
          sx={{
            background: "#009dff",
            color: "white",
            py: 8,
            textAlign: "center",
          }}
          component={motion.div}
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.6 }}
        >
          <Box sx={{ margin: "0px 10% 0% 10%" }}>
            <Typography
              variant="h3"
              component="h2"
              sx={{ fontWeight: "bold", mb: 3, fontSize: "36px" }}
            >
              Get Started with Everest's GATE AI Question Bank - Free
            </Typography>
            <Typography variant="h5" sx={{ mb: 6, fontSize: "18px" }}>
              Join hundreds of WA students preparing smarter and scoring higher
              with Everest's cutting-edge GATE prep platform.
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: { xs: "column", sm: "row" }, // Stack on small screens
                gap: 3,
              }}
            >
              <Button
                variant="contained"
                color="secondary"
                size="large"
                sx={{
                  fontSize: "16px",
                  lineHeight: "24px",

                  // background: "#009dff",
                  background: "linear-gradient(to right, #4f46e5, #9333ea)",
                  px: 4,
                  py: 2,
                  fontWeight: "500",
                  color: "#fff",
                  textTransform: "capitalize",
                  borderRadius: "10px",
                  transition: "all 0.3s ease", // Smooth transition

                  "&:hover": {
                    transform: "translateY(-5px)", // Move up
                    borderWidth: "2px",
                    border: "none",
                    background: "linear-gradient(to right, #4f46e5, #9333ea)",
                    color: "white",
                    borderRadius: "10px",
                  },
                }}
                onClick={() => {
                  navigate("/registration", { state: { path: "minimock" } });
                }}
              >
                Start For Free
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                sx={{
                  fontSize: "14px",
                  lineHeight: "24px",
                  px: 4,
                  py: 2,
                  borderRadius: "10px",
                  fontWeight: "500",
                  borderWidth: "2px",
                  backgroundColor: "white",
                  color: "#009dff",
                  border: "none",
                  textTransform: "capitalize",
                  transition: "all 0.3s ease", // Smooth transition
                  "&:hover": {
                    transform: "translateY(-5px)", // Move up
                    backgroundColor: "white",
                    color: "#009dff",
                    borderRadius: "10px",
                  },
                }}
                onClick={() => scrollToElement("Pricing")}
              >
                View Premium Plans <ArrowForwardIcon />
              </Button>
            </Box>
          </Box>
        </Box>

        {/* Footer */}
        <Box
          sx={{
            backgroundColor: "#111827",
            color: "white",
            py: 6,
            px: 4,
          }}
          // data-aos="fade-up"
        >
          <Container maxWidth="lg" sx={{ px: 4, width: "90%" }}>
            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <Typography
                  variant="h4"
                  component="h2"
                  sx={{ fontWeight: "500", mb: 2, fontSize: "18px" }}
                >
                  Everest GATE
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ mb: 2, fontSize: "15px", color: "#D1D5DB" }}
                >
                  The AI-powered GATE exam preparation platform built by 99+
                  ATAR WA Tutors
                </Typography>
              </Grid>

              <Grid item xs={12} md={3}>
                <Typography
                  variant="h5"
                  sx={{ fontWeight: "500", mb: 2, fontSize: "18px" }}
                >
                  Quick Links
                </Typography>
                {/* <Typography
                  variant="body2"
                  sx={{
                    mb: 1,
                    fontSize: "15px",
                    color: "#D1D5DB",
                    cursor: "pointer",
                  }}
                >
                  About Us
                </Typography> */}
                <Typography
                  variant="body2"
                  sx={{
                    mb: 1,
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: "400",
                    color: "#D1D5DB",
                    cursor: "pointer",
                    "&:hover": {
                      color: "#009dff",
                    },
                  }}
                  onClick={() => scrollToElement("how-it-works")}
                >
                  How it Works
                </Typography>
                <Typography
                  variant="body2"
                  onClick={() => scrollToElement("Pricing")}
                  sx={{
                    mb: 1,
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: "400",
                    color: "#D1D5DB",
                    cursor: "pointer",
                    "&:hover": {
                      color: "#009dff",
                    },
                  }}
                >
                  Pricing
                </Typography>
                {/* <Typography
                  variant="body2"
                  sx={{
                    mb: 1,
                    fontSize: "15px",
                    color: "#D1D5DB",
                    cursor: "pointer",
                  }}
                >
                  Support
                </Typography> */}
              </Grid>

              <Grid item xs={12} md={3}>
                <Typography
                  variant="h5"
                  sx={{ fontWeight: "500", mb: 2, fontSize: "18px" }}
                >
                  Contact
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ mb: 1, fontSize: "15px", color: "#D1D5DB" }}
                >
                  {/* Perth, Western Australia */}
                  3/723 Ranford Road, Harrisdale, WA 6155, Australia
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ mb: 1, fontSize: "15px", color: "#D1D5DB" }}
                >
                  {/* contact@everestgate.com.au */}
                  info@everesttutoring.com.au
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ fontSize: "15px", color: "#D1D5DB" }}
                >
                  {/* +61 8 024 5678 */}
                  +61 404 604 673
                </Typography>
              </Grid>
            </Grid>

            <Box
              sx={{
                borderTop: "1px solid rgba(255, 255, 255, 0.1)",
                mt: 4,
                pt: 4,
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: { xs: "center", sm: "space-between" },
                alignItems: { xs: "center", sm: "center" },
                gap: 2,
                textAlign: { xs: "center", sm: "left" }, // Center text on mobile
              }}
            >
              <Typography
                variant="body2"
                sx={{ fontSize: "15px", color: "#D1D5DB" }}
              >
                © 2025 Everest Tutoring. All rights reserved.
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  gap: 3,
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="body2"
                  onClick={() => {
                    navigate("/privacypolicy");
                  }}
                  sx={{
                    fontSize: "15px",
                    color: "#D1D5DB",
                    cursor: "pointer",
                    "&:hover": { textDecoration: "underline" },
                  }}
                >
                  Privacy Policy
                </Typography>
                <Typography
                  variant="body2"
                  onClick={() => {
                    navigate("/termsandservices");
                  }}
                  sx={{
                    fontSize: "15px",
                    color: "#D1D5DB",
                    cursor: "pointer",
                    "&:hover": { textDecoration: "underline" },
                  }}
                >
                  Terms of Service
                </Typography>
              </Box>
            </Box>
          </Container>
        </Box>
      </Box>
      {/* // video play */}
      {/* Modal for video */}
      <Modal open={openvideo}>
        {/* Video Area with Previews */}
        <>
          <Box sx={{ width: "100%", position: "relative" }}>
            <IconButton
              sx={{
                position: "absolute",
                top: 6,
                right: 38,
                m: 1, // optional: adds margin from edges
                color: "#FFFFFF",
                zIndex: 2,
                backgroundColor: "gray",
              }}
              onClick={handleClosevideo}
            >
              <CloseIcon
                sx={{ fontSize: "20px", color: "white", fontWeight: 600 }}
              />
            </IconButton>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              position: "relative",
              width: "100%",
              height: "100%",
              mb: 2,
            }}
          >
            {/* Left Preview + Arrow */}
            <Box sx={{ width: "10%", position: "relative" }}>
              <IconButton
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translateY(-50%)",
                  color: "#FFFFFF",
                  zIndex: 2,
                }}
                onClick={handlePrevideo}
              >
                <ArrowBackIosNewIcon sx={{ fontSize: "50px" }} />
              </IconButton>
            </Box>

            {/* Center Main Video */}
            <Box sx={{ width: "80%" }}>
              <Box
                component="iframe"
                width="100%"
                src={`${currentVideo.url}?autoplay=1`}
                title={currentVideo.title}
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
                sx={{ borderRadius: "20px", height: "60rem" }}
              />
            </Box>

            {/* Right Preview + Arrow */}
            <Box sx={{ width: "10%", position: "relative" }}>
              <IconButton
                sx={{
                  position: "absolute",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#FFFFFF",
                  zIndex: 2,
                }}
                onClick={handleNextvideo}
              >
                <ArrowForwardIosIcon sx={{ fontSize: "50px" }} />
              </IconButton>
            </Box>
          </Box>
        </>
      </Modal>
    </>
  );
};

export default Landingpage;
